const tableElementTagName = 'atomic-table-element';

export { tableElementTagName as t };

//# sourceMappingURL=table-element-utils-49d22ec6.js.map